module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Row', {
    attrs: {
      "type": "flex"
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24
    }
  }, [_c('h1', {
    staticClass: "mb15",
    staticStyle: {
      "color": "#9b9b9c"
    }
  }, [_c('Icon', {
    staticStyle: {
      "font-weight": "bold"
    },
    attrs: {
      "type": "ios-keypad-outline",
      "size": "25",
      "color": "#9b9b9c"
    }
  }), _vm._v("\n            Listado de campañas\n        ")], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "type": "flex",
      "gutter": 15
    }
  }, _vm._l((_vm.$store.state.campaigns), function(campaign) {
    return _c('i-col', {
      key: ("col_campaign_" + (campaign.id)),
      attrs: {
        "xs": 12,
        "md": 4
      }
    }, [_c('dashboard-card', {
      staticClass: "mb30",
      attrs: {
        "title": campaign.titulo,
        "description": campaign.descripcion || '',
        "route": "/admin/detail"
      },
      on: {
        "click": function($event) {
          _vm.selectCampaign(campaign)
        }
      }
    })], 1)
  }))], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-172271c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/admin/publicidad/PublicidadList.vue
// module id = 597
// module chunks = 1